import { render, staticRenderFns } from "./CountryPage.vue?vue&type=template&id=2f142c19&"
import script from "./CountryPage.vue?vue&type=script&lang=js&"
export * from "./CountryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports